/* Meera Capsule — Meta click-ID capture (Jul 2026)
   Reads fbclid from the landing URL (or the _fbc/_fbp cookies Meta's pixel sets)
   and persists them on the Shopify cart as note attributes:
     fb_click_id  → _fbc value ("fb.1.<ts_ms>.<fbclid>")
     fb_browser_id → _fbp value
   Cart attributes survive Shopify checkout and land on the order as
   note_attributes, where meta-mcp's CAPI Purchase sync reads them to send
   fbc/fbp server-side. Deduped per session via sessionStorage.
   This script must NEVER break the storefront — everything is try/caught. */
(function () {
  'use strict';
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  try {
    var fbc = cookie('_fbc');
    if (!fbc) {
      var fbclid = new URLSearchParams(window.location.search).get('fbclid');
      if (fbclid) fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    }
    var fbp = cookie('_fbp');
    if (!fbc && !fbp) return;

    var sig = (fbc || '') + '|' + (fbp || '');
    var KEY = 'meera_fb_attrs_v1';
    try { if (sessionStorage.getItem(KEY) === sig) return; } catch (e) { /* storage blocked — post anyway */ }

    var attributes = {};
    if (fbc) attributes.fb_click_id = fbc;
    if (fbp) attributes.fb_browser_id = fbp;

    var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      if (r.ok) { try { sessionStorage.setItem(KEY, sig); } catch (e) {} }
    }).catch(function () {});
  } catch (e) {}
})();
